import React from 'react';
import searchicon from '../../../assets/images/searchicon.svg';
import { Form, Tab, Nav } from 'react-bootstrap';
import Oaastab from '../oaastab/Oaastab';
import './audittab.css';

const Audittab: React.FC = () => {
    return (
        <>
            <div className="common_card">
                <div className="top">
                    <div className="top_bar_tittle">
                        <h2>Audit Dashboard</h2>
                    </div>
                </div>
                <Tab.Container id="left-tabs-example" defaultActiveKey="oaastab">
                    <div className="tab_flx audit_tab_flx">
                        <div className='d-flex'>
                            <Nav variant="pills" className="common_tab">
                                <Nav.Item>
                                    <Nav.Link eventKey="oaastab">OAAS</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="ocddtab">OCDD</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="epsdttab">EPSDT</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        <div className="audit_tab_fillter">
                            <Form.Group controlId="search" className='custom_input_flled filled_input_icon mb-0'>
                                <Form.Control type="search" placeholder="Search participant" className='sm_input' />
                                <span className='icon_img cursor-pointer'><img src={searchicon} alt={searchicon} /></span>
                            </Form.Group>
                            <Form.Group controlId="search" className='custom_input_flled filled_input_icon mb-0'>
                                <Form.Select style={{minWidth :'12.6875rem'}} aria-label="Default select example" className='sm_input'>
                                    <option>Fiscal Year</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group controlId="search" className='custom_input_flled filled_input_icon mb-0'>
                                <Form.Select style={{minWidth :'12.6875rem'}} aria-label="Default select example" className='sm_input'>
                                    <option>Region</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </Form.Select>
                            </Form.Group>
                        </div>
                    </div>
                    <Tab.Content>
                        <Tab.Pane eventKey="oaastab">
                            <Oaastab/>
                        </Tab.Pane>
                        <Tab.Pane eventKey="ocddtab">
                            <div className='mt-3'>OCDDwe tab content</div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="epsdttab">
                            <div className='mt-3'>
                                EPSDT tab content
                            </div>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>

            </div>
        </>
    );
};

export default Audittab;